// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.individuals-page .card-body {
  padding: 1.5rem;
}

.individuals-layout {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.individuals-summary-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.individuals-summary-card {
  background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%);
  border: 1px solid #d7e6fb;
  border-radius: 1rem;
  color: #133a63;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem 1.1rem;
  text-align: left;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.individuals-summary-card:hover,
.individuals-summary-card.is-active {
  border-color: #0d6efd;
  box-shadow: 0 12px 30px rgba(13, 110, 253, 0.12);
  transform: translateY(-1px);
}

.individuals-summary-label {
  font-size: 0.9rem;
  font-weight: 600;
}

.individuals-summary-value {
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1;
}

.individuals-relationship-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.individuals-searchable-table {
  border: 1px solid #e3ebf4;
  border-radius: 1rem;
  overflow: hidden;
  padding: 1rem;
  background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);
}

.individuals-searchable-table .card,
.individuals-searchable-table .accordion,
.individuals-searchable-table .table-responsive {
  border-radius: 1rem;
}

.individuals-searchable-table .table {
  margin-bottom: 0;
}

.individuals-searchable-table thead th {
  background: #f6f9fc;
  border-bottom-width: 1px;
  color: #47627d;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.individuals-searchable-table th:last-child,
.individuals-searchable-table td:last-child {
  min-width: 7rem;
  white-space: nowrap;
  width: 7rem;
}

.individuals-searchable-table td:nth-child(1),
.individuals-searchable-table th:nth-child(1) {
  width: 14%;
}

.individuals-searchable-table td:nth-child(2),
.individuals-searchable-table th:nth-child(2) {
  width: 18%;
}

.individuals-searchable-table .btn-primary,
.individuals-searchable-table .btn-outline-primary:hover {
  box-shadow: 0 8px 18px rgba(13, 110, 253, 0.14);
}

.individuals-searchable-table input,
.individuals-searchable-table select {
  border-radius: 0.85rem;
}

.individuals-searchable-table .pagination {
  margin-top: 1rem;
}

@media (max-width: 767px) {
  .individuals-searchable-table {
    padding: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Individuals/Individuals.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".individuals-page .card-body {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.individuals-layout {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.25rem;\r\n}\r\n\r\n.individuals-summary-grid {\r\n  display: grid;\r\n  gap: 1rem;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n}\r\n\r\n.individuals-summary-card {\r\n  background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%);\r\n  border: 1px solid #d7e6fb;\r\n  border-radius: 1rem;\r\n  color: #133a63;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n  padding: 1rem 1.1rem;\r\n  text-align: left;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.individuals-summary-card:hover,\r\n.individuals-summary-card.is-active {\r\n  border-color: #0d6efd;\r\n  box-shadow: 0 12px 30px rgba(13, 110, 253, 0.12);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.individuals-summary-label {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.individuals-summary-value {\r\n  font-size: 1.8rem;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n\r\n.individuals-relationship-strip {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.individuals-searchable-table {\r\n  border: 1px solid #e3ebf4;\r\n  border-radius: 1rem;\r\n  overflow: hidden;\r\n  padding: 1rem;\r\n  background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);\r\n}\r\n\r\n.individuals-searchable-table .card,\r\n.individuals-searchable-table .accordion,\r\n.individuals-searchable-table .table-responsive {\r\n  border-radius: 1rem;\r\n}\r\n\r\n.individuals-searchable-table .table {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.individuals-searchable-table thead th {\r\n  background: #f6f9fc;\r\n  border-bottom-width: 1px;\r\n  color: #47627d;\r\n  font-size: 0.85rem;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.individuals-searchable-table th:last-child,\r\n.individuals-searchable-table td:last-child {\r\n  min-width: 7rem;\r\n  white-space: nowrap;\r\n  width: 7rem;\r\n}\r\n\r\n.individuals-searchable-table td:nth-child(1),\r\n.individuals-searchable-table th:nth-child(1) {\r\n  width: 14%;\r\n}\r\n\r\n.individuals-searchable-table td:nth-child(2),\r\n.individuals-searchable-table th:nth-child(2) {\r\n  width: 18%;\r\n}\r\n\r\n.individuals-searchable-table .btn-primary,\r\n.individuals-searchable-table .btn-outline-primary:hover {\r\n  box-shadow: 0 8px 18px rgba(13, 110, 253, 0.14);\r\n}\r\n\r\n.individuals-searchable-table input,\r\n.individuals-searchable-table select {\r\n  border-radius: 0.85rem;\r\n}\r\n\r\n.individuals-searchable-table .pagination {\r\n  margin-top: 1rem;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .individuals-searchable-table {\r\n    padding: 0.75rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
